import request from "_private/utils/request";

/**
 * 获取批次流通信息列表数据
 * @param {*} data
 */
export function batchCirculation(data) {
  return request({
    url: "/coldTrace/batchCirculation",
    method: "post",
    headers: { type: "json" },
    data
  });
}
/**
 * 字典
 * @param {*} params
 */
export function companyListByType(params) {
  return request({
    url: "/coldTrace/companyListByType",
    method: "get",
    headers: { type: "json" },
    params
  });
}
// 导出批次流通信息页面数据
export function exportBatchCirculation(data) {
  return request({
    headers: { "Content-Type": "application/json", type: "json" },
    responseType: "blob",
    url: "/coldTrace/exportBatchCirculation",
    method: "post",
    data
  });
}
